if (!customElements.get('section-square')) {
  class SectioSquare extends HTMLElement {
    constructor() {
      super();

      this.buttonSquare = this.querySelector('.button-square');
      this.queryString = window.location.search;
      this.url = window.location.href;
      this.urlParams = new URLSearchParams(this.queryString);
      this.urlFetch = `${window.internalApi.baseUrl}/square/authenticate`;
      if (this.buttonSquare) {
        this.buttonSquare.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.classList.add('button-disable');
          if (this.checkUserLogged()) {
            this.getUrlSquare();
          }
        });
      }
    }

    checkUserLogged() {
      return this.setNotlogged();
    }

    setNotlogged() {
      let val = true;
      if (this.dataset.user == '') {
        const tempUrl = new URL(this.url);
        localStorage.setItem(
          'urlReturn',
          this.url.replace(`${tempUrl.protocol}//${tempUrl.host}`, ''),
        );
        localStorage.setItem('isLogged', 'square');
        localStorage.setItem('actionLogged', 'redirection');
        window.location.replace('/account');
        val = false;
      }
      return val;
    }

    getUrlSquare() {
      fetch(this.urlFetch, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.data.hasOwnProperty('installUrl')) {
            this.buttonSquare.classList.add('button-disable');
            window.location.replace(result.data.installUrl);
          } else {
            console.log(result);
          }
        })
        .catch((err) => console.log(err));
    }

    isLogged(user) {
      let val = true;
      if (user == '') {
        localStorage.setItem('urlReturn', this.urlFetch);
        localStorage.setItem('isLogged', 'square');
        localStorage.setItem('actionLogged', 'redirection');
        val = false;
        window.location.replace('/account');
      }

      return val;
    }
  }

  customElements.define('section-square', SectioSquare);
}
